
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">esgehtmirgut.ch</h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Der einfache Lebenszeichen-Service für Menschen, die allein leben 
              und ihre Angehörigen.
            </p>
            <p className="text-gray-300 mb-4">
              Jeden Tag die vier Worte, auf die es ankommt: Es geht mir gut.
            </p>
            {/* Sichtbare Erreichbarkeit schafft Vertrauen – gerade bei einem
                Dienst, dem man einen Angehoerigen anvertraut. */}
            <p className="text-gray-300">
              <a href="tel:+41787923740" className="hover:text-white transition-colors">
                +41 78 792 37 40
              </a>
              {' · '}
              <a href="mailto:office@esgehtmirgut.ch" className="hover:text-white transition-colors">
                office@esgehtmirgut.ch
              </a>
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Service</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/blog" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="/#how-it-works" className="hover:text-white transition-colors">Wie es funktioniert</a></li>
              <li><a href="/#pricing" className="hover:text-white transition-colors">Preise</a></li>
              <li><a href="/#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">Kontakt</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/impressum" className="hover:text-white transition-colors">Impressum</a></li>
              <li><a href="/privacy" className="hover:text-white transition-colors">Datenschutz</a></li>
              <li><a href="/agb" className="hover:text-white transition-colors">AGB</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 esgehtmirgut.ch - Alle Rechte vorbehalten</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
